import {renderSelf} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {requiredNumber, requiredString} from '../factory/createValidationSchema'

export const organizationValidationSchema = {
    [CRUD.CREATE]: (translate = renderSelf) => {
        return {
            title: requiredString(translate),
            privacy: requiredNumber(translate),
        }
    },
}
